export function getDomainName() {
	return location.host.replace('www.','').replace('.net','');
}


// WEBPACK FOOTER //
// ./src/ui/domain-name.js